import { useAppDispatch, useAppSelector } from 'hooks/reduxHooks'
import { useEffect } from 'react'
import fetchLoyaltyLinkedCreditAccount from 'actions/loyalty/fetchLoyaltyLinkedCreditAccount'
import fetchAccountBusiness from 'actions/businessTraveller/fetchBusinessAccount'
import mapSocieteBusinessSettings from 'businessTraveller/api/mappers/businessSettingMapper'

function useBusinessTravellerSocieteDetailsFetcher(targetTier: App.LoyaltyTier) {
  const appDispatch = useAppDispatch()
  const currentBusinessAccount = useAppSelector(state => state.businessTraveller.currentBusinessAccount)
  const businessSettings = useAppSelector(state => state.businessTraveller.businessSettings)
  const employeeNotification = useAppSelector(state => state.businessTraveller.employeeNotification)
  const linkedCreditAccount = useAppSelector(state => state.loyalty.linkedCreditAccount)

  const businessId = currentBusinessAccount?.business?.id

  useEffect(() => {
    if (businessId) {
      appDispatch(fetchLoyaltyLinkedCreditAccount(businessId))
    } else {
      // businessId is undefined — fetch the business account first so we can get one
      appDispatch(fetchAccountBusiness())
    }
  }, [appDispatch, businessId])

  // Current business account is still fetching if status is not success or failed
  const isFetchingBusinessAccount = (currentBusinessAccount?.status !== 'success' && currentBusinessAccount?.status !== 'failed')
  // Business settings is still fetching if status is not success or failed
  const isFetchingBusinessSettings = (businessSettings?.status !== 'success' && businessSettings?.status !== 'failed')
  // Loyalty linked credit account is still fetching if there is a businessId passed and the fetching or initial fetch is true
  const isFetchingLinkedCreditAccount = !!(businessId && (linkedCreditAccount.initial || linkedCreditAccount.fetching))
  // Employee notification is still fetching if status is not success or failed
  const isFetchingEmployeeNotification = (employeeNotification?.status !== 'success' && employeeNotification?.status !== 'failed')

  return {
    isFetching: isFetchingBusinessAccount || isFetchingBusinessSettings || isFetchingLinkedCreditAccount || isFetchingEmployeeNotification,
    societeTierSetting: mapSocieteBusinessSettings(businessSettings?.businessSettings?.societe)?.[targetTier],
    linkedCreditAccount: linkedCreditAccount.data,
    employeeNotification: employeeNotification?.notificationState,
  }
}

export default useBusinessTravellerSocieteDetailsFetcher
